import type { TFunction } from 'i18next'

const PACKAGING_ITEM_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS = {
  validate_requirements:
    'itemDetail.declarationOfConformity.progress.validateRequirements',
  translate_fields:
    'itemDetail.declarationOfConformity.progress.translateFields',
  render_pdf: 'itemDetail.declarationOfConformity.progress.renderPdf',
  persist_output_document:
    'itemDetail.declarationOfConformity.progress.persistOutputDocument',
} as const

type PackagingItemDeclarationOfConformityProgressStep =
  keyof typeof PACKAGING_ITEM_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS

export function packagingItemDeclarationOfConformityProgressMessage(
  step: string,
  translate: TFunction<'packagingSuppliers'>
): string | null {
  const key =
    PACKAGING_ITEM_DECLARATION_OF_CONFORMITY_PROGRESS_STEP_KEYS[
      step as PackagingItemDeclarationOfConformityProgressStep
    ]
  if (key == null) {
    return null
  }
  return translate(key)
}
